import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import AppIcon from '@/components/app/AppIcon.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'FormKitSubmitButtonContent',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppIcon, {
      icon: "spinner",
      spin: true
    }),
    _renderSlot(_ctx.$slots, "default")
  ], 64))
}
}

})